import classNames from 'classnames';
import React from 'react';

import { bsClass, getClassSet, splitBsProps } from './utils/bootstrapUtils';

class MediaList extends React.Component {
  render() {
    const { className, ...props } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);

    const classes = getClassSet(bsProps);

    return (
      <ul
        {...elementProps}
        className={classNames(className, classes)}
      />
    );
  }
}

export default bsClass('media-list', MediaList);



// WEBPACK FOOTER //
// ./src/MediaList.js